class Map {
	mapOptions = {
		zoom: 16,
		mapTypeControl: false,
		streetViewControl: false,
		draggable: true,
		scrollwheel: false,
		zoomControl: true,
		mapTypeId: 'roadmap',
	};

	constructor($el) {
		this.$el = $el;

		if (!this.$el.length) return;

		this.apiKey = 'AIzaSyD3WyxlH0dke3HSyHgm_q752N_inD-1POU';
		this.location = {
			lat: 47.3496,
			lng: 8.2773,
		};

		this.map = null;
		this.marker = null;

		this.markerIcon = 'upload/layout/poi.png';

		this.init();
	}

	init = async () => {
		await this.loadGoogleMaps();

		if (typeof google === 'undefined' || !google.maps) return;

		this.map = new google.maps.Map(this.$el[0], {
			center: this.location,
			zoom: 15,
			mapTypeControl: false,
			streetViewControl: false,
			draggable: false,
			scrollwheel: false,
			zoomControl: false,
			styles: [
				{
					featureType: 'all',
					elementType: 'geometry',
					stylers: [{ color: '#eef1f8' }],
				},
				{
					featureType: 'all',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#273582' }],
				},
				{
					featureType: 'all',
					elementType: 'labels.text.stroke',
					stylers: [{ color: '#eef1f8' }],
				},
				{
					featureType: 'administrative',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#c7d0e6' }],
				},
				{
					featureType: 'landscape',
					elementType: 'geometry',
					stylers: [{ color: '#f4f6fb' }],
				},
				{
					featureType: 'poi',
					stylers: [{ visibility: 'off' }],
				},
				{
					featureType: 'road',
					elementType: 'geometry',
					stylers: [{ color: '#b8c3df' }],
				},
				{
					featureType: 'road',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#9cadd6' }],
				},
				{
					featureType: 'road',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#273582' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry',
					stylers: [{ color: '#9cadd6' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#273582' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#273582' }],
				},
				{
					featureType: 'transit',
					stylers: [{ visibility: 'off' }],
				},
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [{ color: '#d7e0f2' }],
				},
				{
					featureType: 'water',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#273582' }],
				},
			],
		});

		this.marker = new google.maps.Marker({
			position: this.location,
			map: this.map,
			icon: this.markerIcon,
		});
	};

	loadGoogleMaps = () => {
		return new Promise((resolve, reject) => {
			if (typeof google !== 'undefined' && google.maps) {
				resolve();
				return;
			}

			if (document.querySelector('#google-maps-script')) {
				const existingScript = document.querySelector('#google-maps-script');

				existingScript.addEventListener('load', () => resolve());
				existingScript.addEventListener('error', () => reject());

				return;
			}

			const script = document.createElement('script');
			script.id = 'google-maps-script';
			script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey;
			script.async = true;
			script.defer = true;

			script.onload = () => resolve();
			script.onerror = () => reject();

			document.head.appendChild(script);
		});
	};
}

export default Map;
